module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjExLjUiIGN5PSIxMS40NjkyIiByeD0iMTEuNSIgcnk9IjExLjQ2OTIiIGZpbGw9IiNGNUE2MjMiIGZpbGwtb3BhY2l0eT0iMC4zMyIvPgo8ZWxsaXBzZSBjeD0iMTEuNTAxMiIgY3k9IjExLjQ2OTMiIHJ4PSI5LjQ3MzgzIiByeT0iOS40NDg1IiBmaWxsPSIjRjVBNjIzIi8+CjxwYXRoIGQ9Ik0xMS41IDYuNVYxMi41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSIxMS41IiBjeT0iMTUuOCIgcj0iMS4yIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/toast/warning.svg
// module id = lQpv
// module chunks = 46